import React, { useState } from 'react';
import { Form, Input, Button, Row, Col, Alert } from 'antd';
import { UserOutlined, LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { assets } from '../../assets';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { backendURL } from 'src/constant/api/backendURL';
import './signIn.scss';

export const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');

    const onSubmit = async (values: { email: string }) => {
        setLoading(true);
        setError('');
        setSuccess('');
        try {
            const response = await axios.post(`${backendURL}/auth/forgotpassword`, { email: values.email });
            setSuccess(response.data.message || 'Reset link sent to your email.');
        } catch (err: any) {
            setError(err.response?.data?.message || 'Failed to request password reset.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Row gutter={16} className="auth-page-row" style={{ minHeight: '100vh' }}>
            <Col xs={0} sm={0} md={14} lg={14} className="auth-image-col">
                <div className="backgroundSignIn">
                    <img src={assets.signInSignUpBG} alt="" />
                </div>
            </Col>

            <Col xs={24} sm={24} md={10} lg={10} className="auth-form-col" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ width: '90%' }}>
                    <Form
                        name="forgot-password"
                        onFinish={onSubmit}
                        style={{ maxWidth: 350, margin: 'auto' }}
                    >
                        <Link to="/" className="navbar-logo" style={{ textDecoration: 'none', display: 'block', marginBottom: '30px' }}>
                            <img src={require('../../assets/images/The Pickers Stop LOGO.png')} alt="The Pickers Stop" style={{ maxHeight: '60px', width: 'auto' }} />
                        </Link>

                        <h2 style={{ marginBottom: '20px', fontFamily: 'var(--font-heading)' }}>Forgot Password</h2>
                        <p style={{ marginBottom: '20px', color: 'var(--color-text-secondary)' }}>Enter your email address to receive a password reset link.</p>

                        <Form.Item name="email" rules={[{ required: true, message: 'Please input your email!' }, { type: 'email', message: 'Please enter a valid email!' }]}>
                            <Input
                                prefix={<UserOutlined className="site-form-item-icon" style={{ marginRight: '6px' }} />}
                                placeholder="Email address"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" size="large" htmlType="submit" style={{ width: '100%' }} disabled={loading}>
                                {loading ? <Spin indicator={<LoadingOutlined style={{ fontSize: '14px' }} spin />} /> : 'Send Reset Link'}
                            </Button>
                        </Form.Item>
                        
                        {success && <Alert type="success" showIcon message={success} style={{ marginBottom: '20px' }} />}
                        {error && <Alert type="error" showIcon message={error} style={{ marginBottom: '20px' }} />}

                        <div style={{ textAlign: 'center' }}>
                            <Link to="/signIn">Back to Sign In</Link>
                        </div>
                    </Form>
                </div>
            </Col>
        </Row>
    );
};
